import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  GetIbFormSubmissionDetailsRequestType,
  GetIbFormSubmissionDetailsResponseType
} from '../../../services/FormsServices/APIService/types';

import { useFormsService } from '../useFormsService';

interface UseGetIbFormSubmissionDetailsResponseInterface {
  getIbFormSubmissionDetailsAPI: UseMutateAsyncFunction<
    GetIbFormSubmissionDetailsResponseType,
    unknown,
    GetIbFormSubmissionDetailsRequestType,
    unknown
  >;
  error: string;
  status: MutationStatus;
}

const useGetIbFormSubmissionDetails =
  (): UseGetIbFormSubmissionDetailsResponseInterface => {
    const { formsServiceAPI } = useFormsService();

    const getIbFormSubmissionDetails = (
      request: GetIbFormSubmissionDetailsRequestType
    ) => {
      return formsServiceAPI.getIbFormSubmissionDetails(request);
    };

    const { mutateAsync, error, status } = useMutation(
      getIbFormSubmissionDetails,
      {
        mutationKey: ['getIbFormSubmissionDetails']
      }
    );

    return {
      getIbFormSubmissionDetailsAPI: mutateAsync,
      error: error ? getAPIErrorMessage(error) : '',
      status
    };
  };

export { useGetIbFormSubmissionDetails };
